import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Services } from "../../api/Services";
import FormComponent from "./CreateListForm";

// code add By Zohaib
const DropdownComponent = ({
  setIsLoadingClients,
  getTrainerClients,
  lists,
  setLists,
  selectedTabIndex,
  setSelectedTabIndex,
  selectedClients,
  setSelectedClients,
  getTrainerClientsSpecs,
  setSearchUserinput,
  setShowSetting,
}) => {
  const [editStat, setEditStat] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [listName, setListName] = useState("");
  const [selectedusers, setSelectedusers] = useState([]);
  const [userinput, setUserinput] = useState("");
  const [users, setUsers] = useState([]);
  const [usersIds, setUsersIds] = useState([]);

  // Drop Down on click
  const [dropDownClick, setDropDownClick] = useState(false);
  const [showListSettings, setShowLsitSetting] = useState(false);
  const [settingIndex, setSettingIndex] = useState(null);

  // temporary data for edit
  const [editTabID, setEditTabID] = useState(null);
  const [tempName, setTempName] = useState("");
  const [tempUsers, setTempUsers] = useState([]);
  const [changeUserState, setChangeUserState] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [selectedListID, setSelectedListID] = useState(0);
  var [isAddedNewUser, setIsAddedNewUser] = useState(false);
  const [searchPaging, setSearchPaging] = useState([]);

  //Hanlde user input to cahnge clients in form while seraching
  const handleuserinputChange = async (event) => {
    const newInputValue = event ? event.target.value : "";
    setUserinput(newInputValue);

    try {
      if (newInputValue.trim() === "") {
        setUsers([]);
        setSearchPaging([]);
      } else {
        const result = await Services.getProgrammUsers(userinput, 1);
        if (result.status === 200) {
          setUsers(result?.data?.data?.listing);
          setSearchPaging(result?.data?.data?.paging);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // calling the trainer create users list
  const createListName = async (name, user_ids) => {
    try {
      const result = await Services.createTrainerUsersList(name);
      if (result && result.status == 200) {
        const trainer_users_lists_id = result.data.data.id;

        await createUsersList(user_ids, trainer_users_lists_id);
      }
    } catch (error) {
      console.error("An error occurred while creating the list Name:", error);
      toast.error("An error occurred while creating the list Name:", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
  };

  // calling the trainer get users list Names api
  const fetchUsersListNames = async () => {
    setFormLoading(true);
    try {
      const result = await Services.getTrainerUsersLists();
      if (result.status === 200) {
        setFormLoading(false);
        setLists((previousList) => {
          const existingListNames = previousList.map((item) => item.id);

          const newListData = result?.data?.data.filter(
            (item) => !existingListNames.includes(item.id)
          );

          return [...previousList, ...newListData];
        });
      }
    } catch (error) {
      console.error("An error occurred while fetching the list Names:", error);
      toast.error("An error occurred while fetching the list Names:", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    setFormLoading(false);
  };

  // calling the trainer delete users list name api
  const deleteUserListName = async (id) => {
    try {
      const result = await Services.deleteTrainerUsersList(id);
      if (result.status == 200) {
        handleTabClick(0, id, true);
        setLists((prevLists) =>
          prevLists.filter((item, i) => i !== selectedTabIndex)
        );
        toast.success("List Deleted successfully", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      if (result.status == 500) {
        toast.error("Retry an error Ocured", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error(
        "An error occurred while Deleting the users list Name:",
        error
      );
      toast.error("An error occurred while Deleting the users list Name:", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
  };

  // calling the trainer edit users list name
  const editListName = async (name, id) => {
    try {
      const result = await Services.editTrainerUsersList(name, id);
      if (result.status == 200) {
        setLists((previousLists) =>
          previousLists.map((list) =>
            list.id === id ? { ...list, name: name } : list
          )
        );

        toast.success("List Editted successfully", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error("An error occurred while Editing the list Name:", error);
      toast.error("An error occurred while Editing the list Name:", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
  };

  // calling the trainer create users list
  const createUsersList = async (user_ids, trainer_users_lists_id) => {
    try {
      let uniqueUserIds = [...new Set(user_ids.map((item) => item.id))];

      let dataString = JSON.stringify(uniqueUserIds);

      const result = await Services.addTrainerUsersListUser(
        dataString,
        trainer_users_lists_id
      );

      if (result.status == 200) {
        toast.success(
          `List ${editStat == true ? "Edited" : "Created"} Successfully`,
          {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          }
        );
      }
    } catch (error) {
      console.error(
        `An error occurred while ${
          editStat == true ? "editing" : "creating"
        } the list:`,
        error
      );
      toast.error(
        `An error occurred while ${
          editStat == true ? "editing" : "creating"
        } the list:`,
        {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        }
      );
      return;
    }
  };

  // calling the trainer get users list api

  const fetchUsersList = async (id) => {
    setIsLoadingClients(true);
    try {
      const result = await Services.getTrainerUsersListUsers(id);
      if (result.status === 200) {
        const temp = result.data.data.map((item) => item.user_id);
        setUsersIds(temp);
        setTempUsers(temp);
        setSelectedClients(result.data.data);
        setChangeUserState(true);
        getTrainerClientsSpecs(
          result?.data?.data[0].user?.id,
          result?.data?.data[0].user?.image,
          result?.data?.data[0].user?.name
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching the users list:", error);
      toast.error("An error occurred while fetching the users list:", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  // calling the trainer delete users list api
  const deleteUserList = async (id, usersIdz) => {
    try {
      let dataString = JSON.stringify(usersIdz);
      const result = await Services.removeTrainerUsersListUser(dataString, id);
      if (result.status == 200) {
        usersIds === null
          ? handleTabClick(0, id, true)
          : setChangeUserState(true);
        if (editStat == false) await deleteUserListName(id);
      }
    } catch (error) {
      console.error(
        "An error occurred while Deleting the users list Users:",
        error
      );
      toast.error("An error occurred while Deleting the users list Users:", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
  };

  //removing the the users from form selected users
  const removeUser = (item) => {
    const confirmed = window.confirm("Do you want to remove user?");
    if (confirmed) {
      if (selectedusers.includes(item)) {
        setSelectedusers(
          selectedusers.filter((selectedItem) => selectedItem !== item)
        );
        deleteUserList(editTabID, [item.id]);
        setTempUsers(usersIds.filter((selectedId) => selectedId !== item?.id));
        setUsersIds(usersIds.filter((selectedId) => selectedId !== item?.id));
      }
    }
  };

  //select user and adding in selected users in form
  const toggleItem = (item) => {
    if (selectedusers.includes(item)) {
      setSelectedusers(
        selectedusers.filter((selectedItem) => selectedItem !== item)
      );
      setUsersIds(usersIds.filter((selectedId) => selectedId !== item?.id));
    } else {
      setSelectedusers((prevSelectedUsers) => [...prevSelectedUsers, item]);
      setUsersIds((prevUsersIds) => [...prevUsersIds, item?.id]);
      setIsAddedNewUser(true);
    }
  };

  useEffect(() => {
    if (changeUserState === true) {
      setIsLoadingClients(true);
      const changingUserList = () => {
        let filteredUsers = [];
        selectedClients.map((client) => {
          if (usersIds.includes(client.user.id)) {
            filteredUsers.push(client.user);
          }
        });

        setSelectedusers(filteredUsers);
      };

      changingUserList();
      setChangeUserState(false);
      setIsLoadingClients(false);
    }
  });

  // handling the submission of form submit for edit and for new data
  const handleSubmit = async () => {
    setFormLoading(true);
    if (listName.trim() === "") {
      toast.error("List Name cannot be empty", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      setFormLoading(false);
      return;
    }

    if (selectedusers.length === 0) {
      toast.error("Please select at least one user for the list", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      setFormLoading(false);
      return;
    }

    // checking the state of the form
    if (editStat === false) {
      await createListName(listName, selectedusers);
    } else {
      if (listName !== tempName) {
        await editListName(listName, editTabID);
      }
      if (usersIds !== tempUsers && isAddedNewUser === true) {
        await createUsersList(selectedusers, editTabID);
      }
    }
    setUsersIds([]);
    setTempUsers([]);
    setFormLoading(false);
    handleCloseForm();
    await setIsAddedNewUser(false);
  };

  // cloding the form and changie to stares to default
  const handleCloseForm = () => {
    handleTabClick(selectedTabIndex, selectedListID, false);
    setShowForm(false);
    setEditStat(false);
    setListName("");
    setSelectedusers([]);
    setUsers([]);
    setUserinput("");
    setEditTabID(null);
  };

  // Function to handle list deletion
  const handleListDelete = async (index, id) => {
    const confirmed = window.confirm("Do you want to remove list name?");
    if (confirmed) {
      deleteUserList(id, usersIds);

      setUsersIds([]);
      // drop down options
      setDropDownClick(false);
      setShowLsitSetting(false);
      setSettingIndex(null);
    }
  };

  // creating the form component for calling
  const form = () => (
    <FormComponent
      handleCloseForm={handleCloseForm}
      listName={listName}
      setListName={setListName}
      selectedusers={selectedusers}
      userinput={userinput}
      setUsers={setUsers}
      handleSubmit={handleSubmit}
      handleuserinputChange={handleuserinputChange}
      removeUser={removeUser}
      toggleItem={toggleItem}
      users={users}
      editStat={editStat}
      formLoading={formLoading}
      searchPaging={searchPaging}
      setSearchPaging={setSearchPaging}
    />
  );

  // add button for crating new list
  const handleAddButtonClick = async () => {
    handleuserinputChange(null);
    await setSelectedusers([]);

    setShowForm(true);
    // drop down options
    setDropDownClick(false);
    setShowLsitSetting(false);
    setSettingIndex(null);
  };

  //  changing states and calling form when edit butoon pressed
  const editListData = async (index, id) => {
    handleTabClick(index, id, true);
    setEditTabID(id);
    const currentTab = lists[index];

    setShowForm(true);
    setListName(currentTab.name);
    setTempName(currentTab.name);

    handleuserinputChange(null);

    // drop down options
    setDropDownClick(false);
    setShowLsitSetting(false);
    setSettingIndex(null);
    setEditStat(true);
  };

  // changin the tab index and clients list on slected tab clicked
  const handleTabClick = async (index, id, closeDrop) => {
    setSearchUserinput("");

    if (index > 1) fetchUsersList(id);
    else getTrainerClients(index);
    setSelectedTabIndex(index);
    setSelectedListID(id);
    if (closeDrop == true) closeDropDown();
  };

  // chiang states when open drop down button clicked
  const openDropDown = () => {
    setDropDownClick(true);
    fetchUsersListNames();
    handleCloseForm();
    setShowSetting(false);
  };

  // changing the states to defalult when close drop down clicked
  const closeDropDown = async () => {
    setDropDownClick(false);
    setShowLsitSetting(false);
    setSettingIndex(null);
  };

  //  chaing the states when clicked on setting icon
  const showOptions = async (index, id) => {
    handleTabClick(index, id, false);
    setShowLsitSetting(true);
    setSettingIndex(index);
  };

  // changin states when close setting predds
  const hideOptions = () => {
    setShowLsitSetting(false);
    setSettingIndex(null);
  };
  return (
    <div className="drop-down">
      <div
        className="drop-down-head"
        onClick={!dropDownClick ? openDropDown : closeDropDown}
      >
        {!dropDownClick ? (
          <>
            <p className="selectedName">
              {lists[selectedTabIndex].name.length > 40
                ? lists[selectedTabIndex].name.slice(0, 35) + "..."
                : lists[selectedTabIndex].name}
            </p>
            <i class="fa fa-arrow-down" title="Show List"></i>
          </>
        ) : (
          <>
            <p>Select Client List</p>
            <i class="fa fa-arrow-up" title="Hide List"></i>
          </>
        )}
      </div>
      {selectedTabIndex > 1 && (
        <div className="managae-clients">
          <p
            onClick={() => {
              if (
                selectedTabIndex !== 0 &&
                selectedTabIndex !== 1
                //  &&
                // selectedTabIndex !== 2
              )
                editListData(selectedTabIndex, selectedListID);
            }}
          >
            <i className="fa-solid fa-pen-to-square" title="Manage Clients"></i>
            Manage Clients
          </p>
        </div>
      )}
      {dropDownClick && (
        <div className="drop-down-body ">
          <i className="fa fa-times cross-icon" onClick={closeDropDown}></i>
          <div className="list">
            {!formLoading ? (
              lists.map((data, index) => (
                <div key={index}>
                  <div
                    className={`drop-down-list${
                      selectedTabIndex === index ? " active" : ""
                    }`}
                  >
                    <p
                      onClick={() => {
                        handleTabClick(index, data.id, true);
                      }}
                    >
                      {data.name}
                    </p>
                    <div
                      className="setting-icon-box"
                      onClick={() => {
                        !showListSettings && index !== 0 && index !== 1
                          ? //  &&
                            // index !== 2
                            showOptions(index, data.id)
                          : hideOptions();
                      }}
                    >
                      {index !== 0 && index !== 1 && (
                        // index !== 2 &&
                        <i
                          class={
                            settingIndex === index
                              ? "fa fa-cog fa-spin"
                              : "fa fa-cog"
                          }
                          title="List Settings"
                        ></i>
                      )}
                    </div>
                  </div>
                  {showListSettings && settingIndex === index && (
                    <>
                      <div className="drop-down-crud">
                        <div
                          className="list-setting"
                          key={index}
                          onClick={() => {
                            editListData(index, data.id);
                          }}
                        >
                          <i
                            className="fa-solid fa-pen-to-square"
                            title="Show List"
                          ></i>
                          <p>Edit</p>
                        </div>
                        <div
                          className="list-setting"
                          key={index}
                          onClick={() => handleListDelete(index, data.id)}
                        >
                          <i
                            className="fa-solid fa-trash-can"
                            title="Delete List"
                          ></i>
                          <p>Delete</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ))
            ) : (
              <div className="list-name-loading">
                <div className="list-name-loading-gap"></div>
                <div className="three-body">
                  <div className="three-body__dot"></div>
                  <div className="three-body__dot"></div>
                  <div className="three-body__dot"></div>
                </div>
              </div>
            )}
          </div>
          <div className="drop-down-gap"></div>
          <h1 className="add-btn" onClick={handleAddButtonClick}>
            Create New List
          </h1>
        </div>
      )}
      {showForm && form()}
    </div>
  );
};

export default DropdownComponent;
